import * as React from "react";
import {IconProps} from "./IconProps";

export const IconDoubleLeftChevron = React.forwardRef<SVGSVGElement, IconProps>(
    ({color = "currentColor", ...props}, forwardedRef) => {
        return (
            <svg
                width="20" height="20" viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
                ref={forwardedRef}
            >
                <g id="chevron double left">
                    <path id="Icon (Stroke)"
                          d="M9.75592 14.4225C10.0814 14.0971 10.0814 13.5695 9.75592 13.244L7.01184 10.5L9.75592 7.75588C10.0814 7.43044 10.0814 6.90281 9.75592 6.57737C9.43049 6.25193 8.90285 6.25193 8.57741 6.57737L5.24408 9.9107C4.91864 10.2361 4.91864 10.7638 5.24408 11.0892L8.57741 14.4225C8.90285 14.748 9.43049 14.748 9.75592 14.4225ZM15.5893 14.4225C15.9147 14.0971 15.9147 13.5695 15.5893 13.244L12.8452 10.5L15.5893 7.75588C15.9147 7.43044 15.9147 6.90281 15.5893 6.57737C15.2638 6.25193 14.7362 6.25193 14.4107 6.57737L11.0774 9.9107C10.752 10.2361 10.752 10.7638 11.0774 11.0892L14.4107 14.4225C14.7362 14.748 15.2638 14.748 15.5893 14.4225Z"
                          fill={color}/>
                </g>
            </svg>
        );
    },
);
